/**
 * Consulta el estado de una suscripción en el backend que intermedia con PayPal.
 *
 * Dependencias externas:
 * - Firestore para obtener el `subscriptionId` del usuario.
 * - Backend Express para consultar la API de PayPal.
 */
import axios from "axios";
import { getSubscriptionIdFromFirebase } from "../firebase"; // Nueva función para obtener el ID de suscripción
import runtimeConfig from "../config/runtimeConfig";

export const checkSubscriptionStatus = async (userUid) => {
  try {
    // Recupera el ID de suscripción del usuario desde la base de datos (Firebase)
    const subscriptionId = await getSubscriptionIdFromFirebase(userUid);

    if (!subscriptionId) {
      throw new Error("No se encontró el ID de suscripción para este usuario.");
    }

    const response = await axios.get(
      `${runtimeConfig.apiBaseUrl}/check-subscription/${subscriptionId}`
    );

    return response.data.status; // Devuelve el estado de la suscripción
  } catch (error) {
    console.error("Error verificando la suscripción:", error);
    return null;
  }
};
